var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderResourcesViewDataServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2419 33.2611C11.1399 32.6718 11.8275 31.8509 12.3396 31.0231C12.4378 30.8617 12.4449 30.6582 12.3607 30.4899C11.7433 29.3042 11.3434 28.0133 11.2241 26.6452C10.6067 19.9029 16.7666 13.8201 24.9752 13.0765C33.1838 12.3258 40.34 17.1878 40.9574 23.93C41.5748 30.6723 35.4148 36.755 27.2063 37.4987C23.0248 37.8776 19.124 36.8041 16.2124 34.7695C16.0861 34.6783 15.9247 34.6503 15.7774 34.6924C13.406 35.2747 11.4065 34.6713 10.3191 34.1872C9.92617 34.0188 9.89109 33.4926 10.2419 33.2611Z",
    fill: "#9DB6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21C18 20.4477 18.4477 20 19 20H27.5C28.0523 20 28.5 20.4477 28.5 21C28.5 21.5523 28.0523 22 27.5 22H19C18.4477 22 18 21.5523 18 21Z",
    fill: "#294C94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 25C18 24.4477 18.4477 24 19 24H35C35.5523 24 36 24.4477 36 25C36 25.5523 35.5523 26 35 26H19C18.4477 26 18 25.5523 18 25Z",
    fill: "#294C94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 29C18 28.4477 18.4477 28 19 28H35C35.5523 28 36 28.4477 36 29C36 29.5523 35.5523 30 35 30H19C18.4477 30 18 29.5523 18 29Z",
    fill: "#294C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderResourcesViewDataServices);
export default __webpack_public_path__ + "static/media/HeaderResourcesViewDataServices.d2248f3cb038fae5fe55ff55f1bedd9e.svg";
export { ForwardRef as ReactComponent };